import * as React from 'react';

export const MasteryLevel1SVG = () => (
  <svg width="38" height="44" viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.4545 13.6547L19 5.3094L4.54552 13.6547V30.3453L19 38.6906L33.4545 30.3453V13.6547Z"
      fill="white"
      stroke="#FFC936"
      strokeWidth="4"
    />
    <path
      d="M15.4906 29V27.12H18.3306V18.76H15.9906V17.32C16.6173 17.2 17.1639 17.06 17.6306 16.9C18.0973 16.7267 18.5306 16.52 18.9306 16.28H20.6506V27.12H23.1506V29H15.4906Z"
      fill="black"
    />
  </svg>
);
